import { render } from "./CollectionLayoutHarvestLimit.vue?vue&type=template&id=5a379d3e"
import script from "./CollectionLayoutHarvestLimit.vue?vue&type=script&lang=js"
export * from "./CollectionLayoutHarvestLimit.vue?vue&type=script&lang=js"

import "./CollectionLayoutHarvestLimit.vue?vue&type=style&index=0&id=5a379d3e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__